import styled, { keyframes } from "styled-components";

import { pickRandomColor } from "@utils/pickRandomColor";

import {
  absoluteCenter,
  alignItemsCenter,
  alpha,
  bp,
  circle,
  flexCenter,
  flexColumn,
  marginInlineAuto,
  media,
  pseudo,
  rem,
  size,
} from "@styles/Utilities.styled";


const pulse = keyframes`
  to {
    opacity: 0.1;
    scale: 2;
  }
`;

export const StyledSidebar = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: var(--sidebar-width);
  height: calc(100svh - var(--footer-height));
  background-color: var(--clr-white);
  /* z-index: 1; */ // appears on top of modal overlay
  /* box-shadow: 3px 0 20px ${alpha("var(--clr-black)", 0.1)}; */
  border-right: 1px solid ${alpha("var(--clr-black)", 0.1)};
  z-index: 1;

  .sidebar-content {
    ${flexColumn}
    gap: 0.25rem;
    height: 100%;
    padding-top: 1.5rem;
    padding-bottom: 0.75rem;
    /* outline: 1px solid red; */

    .sidebar-item {
      &:first-child {
        ${flexCenter}
        padding-block: 0.75rem;
        ${marginInlineAuto("60%")};
        /* outline: 1px solid blue; */

        ${media(bp.large1)} {
          width: 75%;
          margin-right: 2.5rem;
        }
      }

      &:nth-child(2) {
        margin-top: 2rem;
      }

      &.logout {
        /* border-top: 1px solid var(--clr-gray-150); */
        /* width: 90%; */
        /* margin-inline: auto; */
        button {
          svg {
            /* transform: scaleX(-1); */
            font-size: 1.25rem;
            margin-right: 0.75rem;

            ${media(bp.large1)} {
              margin-left: -0.25rem;
              margin-right: 0.5rem;
            }

            path {
              fill: var(--clr-primary-700);
            }
          }

          .title {
            color: var(--clr-primary-700);
            text-transform: capitalize;
          }
        }
      }

      &:nth-last-child(2) {
        margin-top: auto;
      }

      &:last-child {
        position: relative;

        .popup-btn {
          ${size("100%")}
          ${alignItemsCenter}
          gap: 0.75rem;
          border-top: 1px solid var(--clr-gray-150);
          padding-top: 0.75rem;

          ${media(bp.large1)} {
            width: 85%;
            margin-left: 1rem;
            /* outline: 1px solid blue; */
          }
        }

        .avatar {
          position: relative;
          ${flexCenter}
          ${circle(rem(40))}
          min-width: ${rem(40)};
          margin-inline: auto;
          outline: 1px solid var(--clr-gray-150);

          ${media(bp.large1)} {
            margin-inline: 0;
          }

          span {
            ${absoluteCenter}
            ${flexCenter}
            ${circle("88%")}
            font-size: ${rem(18)};
            background-color: ${pickRandomColor()};
            color: var(--clr-primary-700);
          }
        }

        .popup {
          display: none;
          position: absolute;
          left: 105%;
          bottom: 0;
          z-index: 11;

          &.appear {
            display: block;
            background-color: var(--clr-white);
            padding: 0.5rem 1rem;
            border-radius: var(--border-radius-3);
            box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
              hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
          }

          .name {
            font-size: ${rem(14)};
            color: var(--clr-primary-700);
          }

          .role {
            color: var(--clr-gray-400);
            font-size: ${rem(13)};
            text-transform: capitalize;
            text-align: left;
            line-height: 1.3;
          }
        }

        .text-content {
          display: none;
          line-height: 1.2;

          ${media(bp.large1)} {
            ${flexColumn}
            flex-grow: 1;
            gap: 0.25rem;
            /* outline: 1px solid red; */
          }

          .name {
            font-size: ${rem(14)};
            color: var(--clr-primary-700);
            width: fit-content;
          }

          .role {
            color: var(--clr-gray-400);
            font-size: ${rem(13)};
            text-align: left;
            text-transform: capitalize;
            width: fit-content;
          }
        }
      }

      a,
      button:not(.popup-btn, .mantine-InputBase-input) {
        position: relative;
        ${flexColumn}
        align-items: center;
        gap: 0.35rem;
        width: 100%;
        padding-block: 1.75rem;

        ${media(bp.large1)} {
          flex-direction: row;
          gap: 0.75rem;
          padding-block: 1rem;
          padding-inline-start: 1.75rem;
        }

        &.active {
          position: relative;
          color: var(--clr-primary-400);

          &::before {
            ${pseudo}
            top: 0;
            left: 0;
            ${size("100%")}
            background-color: var(--clr-primary-100);
          }

          &::after {
            ${pseudo}
            top: 0;
            left: -3px;
            ${size("8px", "100%")}
            background-color: var(--clr-primary-400);
            border-radius: 100vmax;
          }

          .icon-wrapper {
            svg {
              &:first-child {
                opacity: 0;
              }
              &:nth-child(2) {
                opacity: 1;
              }

              path {
                fill: var(--clr-primary-400);
              }
            }
          }
        }

        &.inactive {
          ::before,
          ::after {
            content: none;
          }
          cursor: default;
          color: var(--clr-gray-300);
        }

        .icon-wrapper {
          position: relative;
          margin-right: 0.35rem;

          ${media(bp.large1)} {
            margin-right: 0.75rem;
            padding-left: 0.75rem;
          }

          svg {
            font-size: 1.5rem;
            ${absoluteCenter}
            transition: opacity 0.1s;

            &:first-child {
              opacity: 1;
            }
            &:nth-child(2) {
              opacity: 0;
            }
          }
        }

        .title-wrapper {
          position: relative;
          ${size("fit-content", "100%")};
          /* outline: 1px solid red; */

          .admin-icon {
            position: absolute;
            top: -0.25rem;
            right: -0.85rem;
            color: var(--clr-notification);

            ${media(bp.large1)} {
              display: none;
            }
          }

          .admin-badge {
            display: none;
            position: absolute;
            top: 0;
            right: ${rem(-51)};
            height: ${rem(18)};
            padding-inline: 0.25rem;

            ${media(bp.large1)} {
              display: block;
            }
          }
        }

        .title {
          display: none;
          font-size: ${rem(12)};
          text-transform: capitalize;

          ${media(bp.large1)} {
            display: block;
            font-size: ${rem(14)};
          }
        }

        .notification {
          position: absolute;
          top: 10%;
          right: 20%;
          ${flexCenter}
          ${size(rem(28), rem(18))}
          border-radius: 100vmax;
          color: var(--clr-white);
          font-size: ${rem(10)};
          font-weight: 500;
          line-height: 1;
          /* font-family: var(--font-secondary); */
          background-color: var(--clr-notification);
          z-index: 1;

          ${media(bp.large1)} {
            top: 50%;
            transform: translateY(-50%);
            right: 1.5rem;
            height: ${rem(20)};
            width: ${rem(35)};
            font-size: ${rem(12)};
          }

          &::before {
            ${pseudo}
            inset: 0;
            border-radius: inherit;
            background-color: var(--clr-notification-100);
            animation: ${pulse} infinite linear 1.5s;
            z-index: -1;
          }
        }
      }

      // Fixing patients icon being too thin
      &:nth-child(2) {
        a {
          svg {
            stroke-width: 0.1;
          }
        }
      }

      // Fixing calendar icon appearing too big
      &:nth-child(3) {
        a {
          svg {
            font-size: 1.35rem;
          }
        }
      }
    }
  }
`;
